import { getErrorJson } from '@mm/utils';
import { showDeleteErrorModal } from '../actions/viewActions';
import AudiencesCRUDActions from '../actions/AudiencesCRUDActions';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import commonHandler from './common-handler';

export const common = dispatch => async (error, botId) => {
  if (error.status === UNPROCESSABLE_ENTITY) {
    const parsed = await getErrorJson(error);
    dispatch(showDeleteErrorModal(parsed && parsed.errors));
    dispatch(AudiencesCRUDActions.retrieveAll(botId));
    dispatch(AudiencesCRUDActions.unbusy());
  } else {
    commonHandler(dispatch)(error);
    throw error;
  }
};
